import React from 'react';
import {DataItem, TextInput} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {IDeveloperField} from 'dromo-uploader-react';

interface DisplayProps {
  value: string;
}

interface Props {
  valueKey: string;
}

export const Import = (
  key: string = 'city',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'City',
  key,
});

const resolveDisplayValue = (value: string) => {
  return value;
};

const CityDisplay = ({value}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>City</Text>
      <Text style={[Typography.P3]}>{resolveDisplayValue(value)}</Text>
    </DataItem>
  );
};

const CityInput = ({valueKey}: Props) => {
  return (
    <TextInput
      valueKey={(valueKey ? valueKey + '.' : '') + 'city'}
      name={'City'}
      required={false}
    />
  );
};

export const validation = () => Yup.string().required('City is required');

export const Display = CityDisplay;
export const Input = CityInput;
export const Value = resolveDisplayValue;

export default CityInput;
